
import React from 'react';
import Layout from '@/components/Layout/Layout';
import GraphingCalculator from '@/components/Calculator/GraphingCalculator';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const GraphingCalculatorPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/calculators" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Calculators
          </Link>
          <h1 className="text-3xl font-bold mb-2">Graphing Calculator</h1>
          <p className="text-gray-600 mb-6">
            Visualize mathematical functions and equations with this interactive graphing tool.
          </p>
        </div>
        
        <div className="mb-8">
          <GraphingCalculator />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Graphing Calculator</h2>
          <p>
            The graphing calculator allows you to plot mathematical functions and visualize 
            equations. It's ideal for students, teachers, and professionals who need to 
            understand mathematical relationships graphically.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Features</h3>
          <ul className="list-disc ml-6">
            <li>Plot multiple functions simultaneously</li>
            <li>Interactive graph with zoom and pan capabilities</li>
            <li>Support for various function types (polynomial, trigonometric, logarithmic)</li>
            <li>Adjustable viewing window and scale</li>
            <li>Trace function values across the graph</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use</h3>
          <p>
            Enter your function in the input field using standard mathematical notation 
            (e.g., y=x^2 for a parabola). Use the graph controls to adjust the viewing window 
            or to zoom in/out for a better view of specific regions.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default GraphingCalculatorPage;
